import { useFormContext } from 'react-hook-form';
import { FormField } from 'ui/formField';
import { BasicSelectField } from 'lib/iterable-hook-form';
import { useSendingPlatformsQueryContext } from 'modules/sendingPlatforms/contexts';
import { SmsSenderSchema } from '../../../../contexts/SmsSenderFormProvider';
import { SMS_SENDER_FORM_FIELD_NAMES, MessageType } from '../../../../types';

const { MESSAGE_TYPE_ID } = SMS_SENDER_FORM_FIELD_NAMES;

export const MessageTypeField = ({ name }: { name: string }) => {
  const { smsMessageTypes } = useSendingPlatformsQueryContext();

  const {
    formState: { errors },
  } = useFormContext<SmsSenderSchema>();

  const messageTypeIdError = errors[MESSAGE_TYPE_ID]?.message;

  const messageTypeOptions = (smsMessageTypes as MessageType[]).map((messageType) => ({
    id: String(messageType.id),
    label: messageType.name,
    value: messageType.id,
  }));
  const options = [{ id: '0', label: 'None', value: 0 }, ...messageTypeOptions];

  return (
    <FormField
      inputId="sms-sender-message-type-id"
      helpText="When a user texts in to unsubscribe, if the number has a message type binding configured, then the user will be unsubscribed only from that message type, rather than all SMS channels."
      labelText="Optional message type binding"
      errorText={messageTypeIdError}
      hasError={!!messageTypeIdError}
    >
      <BasicSelectField
        id="sms-sender-message-type-id"
        name={name}
        defaultValue={options[0].value}
        options={options}
        placeholder={options[0].label}
      />
    </FormField>
  );
};
